export default "__VITE_ASSET__Chwek8PH__"